// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__Svbbv","container":"style_container__wEb0y","description":"style_description__SAF8x","social":"style_social__ZQiYL"};